import { gql } from "@apollo/client";
import { TICKET_POOL_FRAGMENT } from "ticketPool";
import { EVENT_FRAGMENT } from "event/fragments/event";
import { FILE_FRAGMENT } from "file/fragments";
import { VENUE_FRAGMENT } from "venue/fragments";
import { IMAGE_FRAGMENT } from "image/fragments";

import { TICKET_FRAGMENT } from "./ticket";

export const TICKET_WITH_RELATIONS_FRAGMENT = gql`
  ${TICKET_FRAGMENT}
  ${TICKET_POOL_FRAGMENT}
  ${EVENT_FRAGMENT}
  ${VENUE_FRAGMENT}
  ${IMAGE_FRAGMENT}
  ${FILE_FRAGMENT}
  fragment TicketWithRelations on Ticket {
    ...Ticket
    ticketPool @include(if: $ticketPoolInclude) {
      ...TicketPool
      event @include(if: $eventInclude) {
        ...Event
        venue {
          ...Venue
          image {
            ...Image
          }
        }
      }
    }
    file @include(if: $fileInclude) {
      ...File
    }
    order @include(if: $orderInclude) {
      ...Order
    }
  }
`;
